import { Tab, Tabs } from '@mui/material';
import { colorTokens } from '@rideiq/shared/components/variables';

import { SECTION_KEYS, SECTION_LABELS, SectionKey } from '../types';

type SectionTabsProps = {
  activeSection: SectionKey;
  onScrollTo: (section: SectionKey) => void;
};

export const SectionTabs = ({ activeSection, onScrollTo }: SectionTabsProps) => (
  <Tabs
    value={activeSection}
    variant="scrollable"
    scrollButtons={false}
    aria-label="Rider form sections"
    data-testid="section-tabs"
    sx={{
      minHeight: 'unset',
      '& .MuiTab-root': {
        padding: '12px 16px',
        margin: 0,
        minHeight: 'unset',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: '0.1px',
        color: '#3a3c3d',
        '&:before': { display: 'none' },
      },
      '& .MuiTab-root.Mui-selected': { color: colorTokens.primary.main },
    }}
  >
    {SECTION_KEYS.map((key) => (
      <Tab
        key={key}
        label={SECTION_LABELS[key]}
        value={key}
        onClick={() => onScrollTo(key)}
        data-testid={`section-tab-${key}`}
      />
    ))}
  </Tabs>
);
